import BlTextListMv from './BlTextListMv.vue'

BlTextListMv.install = function(Vue) {
  Vue.component(BlTextListMv.name, BlTextListMv)
}

export default BlTextListMv
